import { useCallback } from 'react'
import { useParams } from 'react-router'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'
import SellTicketFinishedStep from './Steps/SellTicketFinishedStep'

interface SingleSellTicketProps extends TableComponentProps { }

const SingleSellTicket: React.FC<SingleSellTicketProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/tpv/sellTicket/orderProduct/createSellTicketProduct', { OrderId }],
        getData: ['/api/app/order/tpv/sellTicket/getSellTicketComplete', { id: OrderId }],
        updateData: '/api/app/order/tpv/sellTicket/orderProduct/updateSellTicketProduct',
        delete: '/api/app/order/tpv/sellTicket/orderProduct/deleteSellTicketProduct',
        updateHeaderData: '/api/app/order/tpv/sellTicket/updateSellTicket',
        getSubProducts: ['/api/app/order/tpv/sellTicket/orderProduct/getAllSubSellTicketProducts', ['CustomerId']],
        updateOrderLines: '/api/app/order/tpv/sellTicket/updateSellTicketNLines',
        printTags: '/api/app/order/tpv/sellTicket/printSellTicketTags'
    }
    const skipAddRow = useCallback(() => {
        return true
    }, [])
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'sell.tickets', skipAddRow })
    return <SellTicketFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
}

export default SingleSellTicket